import React from 'react';
import './index.scss';

const Carrusel = () => (
    <>
        <div>
            <div className='img-changer'></div>
        </div>
    </>
);

export default Carrusel;
